import { render } from "./form-file-button.vue?vue&type=template&id=802362d4"
import script from "./form-file-button.vue?vue&type=script&lang=js"
export * from "./form-file-button.vue?vue&type=script&lang=js"
script.render = render

export default script